(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bourdua-size-studio"] && !Shopify.designMode) return;
  try {
    
  function initBourduaSizeGuide(root) {
    if (!root || root.dataset.bdReady === 'true') return;

    root.dataset.bdReady = 'true';

    var sizeButtons = root.querySelectorAll('[data-size-button]');
    var sceneButtons = root.querySelectorAll('[data-scene-button]');
    var sizeTitle = root.querySelector('[data-size-title]');
    var selectedSize = root.querySelector('[data-selected-size]');
    var sizeCopy = root.querySelector('[data-size-copy]');

    sizeButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var size = button.getAttribute('data-size-button');
        root.setAttribute('data-size', size);

        sizeButtons.forEach(function(item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        var title = button.getAttribute('data-title') || '';
        var shortTitle = title.split(' · ')[0];
        var copy = button.getAttribute('data-copy') || '';

        if (sizeTitle) sizeTitle.textContent = title;
        if (selectedSize) selectedSize.textContent = shortTitle;
        if (sizeCopy) sizeCopy.textContent = copy;
      });
    });

    sceneButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var scene = button.getAttribute('data-scene-button');
        root.setAttribute('data-scene', scene);

        sceneButtons.forEach(function(item) {
          var active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });
  }

  function initAllBourduaSizeGuides(scope) {
    var container = scope || document;
    container.querySelectorAll('[data-bd-size-guide]').forEach(initBourduaSizeGuide);
  }

  initAllBourduaSizeGuides(document);

  document.addEventListener('shopify:section:load', function(event) {
    initAllBourduaSizeGuides(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bourdua-welcome-overlay"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var overlay = document.querySelector('[data-bd-welcome]');
    if (!overlay || overlay.dataset.ready === 'true') return;
    overlay.dataset.ready = 'true';

    var designMode = Boolean(window.Shopify && window.Shopify.designMode);
    var alreadySeen = false;

    try {
      alreadySeen = sessionStorage.getItem('bourdua-welcome-seen-v3') === '1';
    } catch (e) {}

    if (alreadySeen && !designMode) {
      overlay.remove();
      return;
    }

    try {
      sessionStorage.setItem('bourdua-welcome-seen-v3', '1');
    } catch (e) {}

    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-visible');
    document.documentElement.classList.add('bd-welcome-lock');

    window.setTimeout(function () {
      overlay.classList.add('is-leaving');
      document.documentElement.classList.remove('bd-welcome-lock');

      window.setTimeout(function () {
        overlay.remove();
      }, 850);
    }, designMode ? 2800 : 2250);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
